import { useEffect, useState } from 'react';
import { getHttpInstance } from '@app/services/defaultHttpService';

const useMarketingConsentResponse = ({ url, method, data }) => {
  const [apiResponse, setApiResponse] = useState({});

  useEffect(() => {
    const responseData = async () => {
      if (url) {
        const http = getHttpInstance();
        try {
          const response = await http.request({ url, method, data });
          setApiResponse(response);
        } catch (error) {
          console.error('Error fetching data:', error);
          setApiResponse(null);
        }
      }
    };
    responseData();
  }, []);
  return { apiResponse };
};

export default useMarketingConsentResponse;
